import React from "react";

export const DemandResponse = [
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col60">
      <h4 className="slideTitle">
        Demand Response programs can help your business in many ways while
        providing a critical service to help keep the power grid balanced.
      </h4>
      <p>
        Our Demand Response agreements provide you with{" "}
        <strong>
          advanced notice of peak days to reduce your cost of electricity.
        </strong>
      </p>
      <ul className="shell_bullets_list">
        <li>
          Reduce energy consumption during peak periods of demand on the grid
        </li>
        <li>
          Save on energy costs through insights and peak day notifications
        </li>
      </ul>
      <p>
        We have the expertise to find a program and develop a customized{" "}
        <strong>load reduction strategy that fits your needs</strong> with
        minimal disruption to your business.
      </p>
      <ul className="shell_bullets_list">
        <li>Economic demand response</li>
        <li>Call option based demand response</li>
        <li>ISO capacity, emergency and ancillary demand response</li>
        <li>Utility emergency and tariff cost management response</li>
        <li>
          Combinations of the above during different times of the day and year
        </li>
      </ul>
    </div>
    <div className="colRight col40 solidColourContainer align-self-start">
      <h4 className="slideTitle">Key Benefits</h4>
      <ul className="shell_bullets_list icons_list">
        <li>
          <img
            alt=""
            src="images/airport-keybenefits-cost.svg"
            height="auto"
            width="auto"
          />
          <span>
            <strong>Cost control / reductions</strong>
          </span>
        </li>
        <li>
          <img
            alt=""
            src="images/airport-keybenefits-operational-efficiency.svg"
            height="auto"
            width="auto"
          />
          <span>
            <strong>Improved operational efficiency </strong>through predictive energy peak
          </span>
          
        </li>
        <li>
          <img
            alt=""
            src="images/airport-keybenefits-grow.svg"
            height="auto"
            width="auto"
          />
          <span>
            <strong>Grow sustainability </strong>through energy efficiencies
          </span>
        </li>
      </ul>
    </div>
  </div>,
];
